import { Record } from 'immutable';
import { actionTypes } from './tenant.actions';

export const TenantReducerState = Record({
  err: null,
  isFetching: false,
  currentTenant: null,
  isValid: false
});

export const TenantState = Record({
  id: null,
  name: null,
  logoUrl: null,
  slug: null,
  absoluteUrl: null,
  featureList: [],
  integrationType: '',
});

export const tenantReducer = (state = new TenantReducerState(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_CURRENT_TENANT_BEGIN:
      return new TenantReducerState({
        isFetching : true
      });
    case actionTypes.FETCH_CURRENT_TENANT_SUCCESS:
      return new TenantReducerState({
        currentTenant : new TenantState(action.data),
        isValid : true
      });
    case actionTypes.FETCH_CURRENT_TENANT_FAILURE:
      return new TenantReducerState({
        err : action.err,
        isValid : true
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/tenantInfo/tenant.reducer.js